import IconLinkButton from "components/common/controls/IconLinkButton";
import viewIconSvg from "static/images/view-icon.svg";

interface Props {
  viewClicked: () => void;
}

export default function PromineoViewActionColumnButton(props: Props) {
  const { viewClicked } = props;

  const handleViewClick = () => {
    viewClicked();
  };

  return (
    <>
      <IconLinkButton
        text="License"
        icon={viewIconSvg}
        onClick={handleViewClick}
      />
    </>
  );
}
